"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ShareScrollElement = _interopRequireDefault(require("../decorators/ShareScrollElement"));

var _UIScrollContainer = _interopRequireDefault(require("../scroll/UIScrollContainer"));

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _UIBox = _interopRequireDefault(require("./UIBox"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: auto;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var AutoHeightScrollContainer = (0, _styledComponents.default)(_UIScrollContainer.default.defaultProps.ScrollContainer).withConfig({
  displayName: "UIScrollingColumn__AutoHeightScrollContainer",
  componentId: "sc-7rj8q1-0"
})(_templateObject());
var UIScrollingColumn = (0, _react.forwardRef)(function (props, ref) {
  var className = props.className,
      children = props.children,
      flexBasis = props.flexBasis,
      flexGrow = props.flexGrow,
      flexShrink = props.flexShrink,
      footerClassName = props.footerClassName,
      footerContent = props.footerContent,
      headerClassName = props.headerClassName,
      headerContent = props.headerContent,
      maxHeight = props.maxHeight,
      Overhang = props.Overhang,
      scrollDirection = props.scrollDirection,
      scrollElementRef = props.scrollElementRef,
      rest = (0, _objectWithoutProperties2.default)(props, ["className", "children", "flexBasis", "flexGrow", "flexShrink", "footerClassName", "footerContent", "headerClassName", "headerContent", "maxHeight", "Overhang", "scrollDirection", "scrollElementRef"]);
  return _react.default.createElement(_UIBox.default, (0, _extends2.default)({}, rest, {
    basis: flexBasis,
    className: (0, _classnames.default)('private-scroll-columns__column', className),
    grow: flexGrow,
    shrink: flexShrink,
    ref: ref
  }), _react.default.createElement("div", {
    className: "private-scroll-columns__inner",
    style: {
      maxHeight: maxHeight
    }
  }, headerContent && _react.default.createElement("header", {
    className: (0, _classnames.default)('private-scroll-columns__header', 'has--vertical-spacing', headerClassName)
  }, headerContent), _react.default.createElement(_UIScrollContainer.default, {
    className: "private-scroll-columns__column--stretch",
    Overhang: Overhang,
    scrollDirection: scrollDirection,
    scrollElementRef: scrollElementRef,
    ScrollContainer: AutoHeightScrollContainer
  }, children), footerContent && _react.default.createElement("footer", {
    className: (0, _classnames.default)('private-scroll-columns__footer', 'has--vertical-spacing', footerClassName)
  }, footerContent)));
});
UIScrollingColumn.propTypes = {
  children: _propTypes.default.node,
  flexBasis: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  flexGrow: _propTypes.default.number,
  flexShrink: _propTypes.default.number,
  footerClassName: _propTypes.default.string,
  footerContent: _propTypes.default.node,
  headerClassName: _propTypes.default.string,
  headerContent: _propTypes.default.node,
  maxHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  Overhang: _UIScrollContainer.default.propTypes.Overhang,
  scrollDirection: _UIScrollContainer.default.propTypes.scrollDirection,
  scrollElementRef: _refObject.default.isRequired
};
UIScrollingColumn.defaultProps = {
  scrollDirection: 'vertical'
};
UIScrollingColumn.displayName = 'UIScrollingColumn';

var _default = (0, _ShareScrollElement.default)(UIScrollingColumn);

exports.default = _default;
module.exports = exports.default;